export class ParserError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ParserError";
  }
}

export class InternalParserError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "InternalParserError";
  }

  public static missingValue(name: string): InternalParserError {
    return new InternalParserError(`Missing value for <${name}>`);
  }

  public static unexpectedNode(name: string): InternalParserError {
    return new InternalParserError(`Unexpected node <${name}>`);
  }
}
